import { JsonProperty } from 'json-typescript-mapper';
import { Marketday } from './marketday.model';
import { Salesunit } from './salesunit.model';
import { Contact } from './contact.model';
import { User } from './user.model';

export enum DiscountType {
  Single = <any>'Single',
  Periodic = <any>'Periodic',
  SocialOrganization = <any>'SocialOrganization'
}

export class Discount {

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('type')
  public type?: DiscountType;

  @JsonProperty('percentage')
  public percentage?: number;

  @JsonProperty('comment')
  public comment?: string;

  @JsonProperty({clazz: Marketday, name: 'marketday'})
  public marketday?: Marketday;

  @JsonProperty({clazz: Salesunit, name: 'salesunit'})
  public salesunit?: Salesunit;

  @JsonProperty({clazz: Contact, name: 'merchant'})
  public merchant?: Contact;

  @JsonProperty('start')
  public start?: string;

  @JsonProperty('end')
  public end?: string;

  @JsonProperty('created')
  public created?: string;

  @JsonProperty({clazz: Contact, name: 'createdBy'})
  public createdBy?: Contact;

  @JsonProperty('updated')
  public updated?: string;

  @JsonProperty({clazz: Contact, name: 'updatedBy'})
  public updatedBy?: Contact;

  constructor() {
    this.id = void 0;
    this.type = void 0;
    this.percentage = void 0;
    this.comment = void 0;
    this.marketday = void 0;
    this.salesunit = void 0;
    this.merchant = void 0;
    this.start = void 0;
    this.end = void 0;
    this.created = void 0;
    this.createdBy = void 0;
    this.updated = void 0;
    this.updatedBy = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/discount.model.ts